export default __webpack_public_path__ + "static/media/Slack.0024f3b4.png";